var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUkulele = function SvgUkulele(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.185 9.871a1.375 1.375 0 1 0-.144-2.746 1.375 1.375 0 0 0 .144 2.746m.524 4.986a1.375 1.375 0 1 0-.144-2.746 1.375 1.375 0 0 0 .144 2.746M21.8 9.87a1.375 1.375 0 1 0 .143-2.746 1.375 1.375 0 0 0-.144 2.747m-.503 4.782a1.375 1.375 0 1 0 .144-2.746 1.375 1.375 0 0 0-.144 2.746",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9.501 3.215a6.14 6.14 0 0 1-3.097.605 1.23 1.23 0 0 0-1.307 1.31c.236 3.434.672 9.762.802 11.544.021.29.17.55.408.72l1.482 1.058a1 1 0 0 1 .42.814V22h7.641v-2.742a1 1 0 0 1 .409-.806l1.433-1.05a1 1 0 0 0 .407-.738l.803-11.533a1.228 1.228 0 0 0-1.307-1.311 6.14 6.14 0 0 1-3.096-.605l-1.624-.79a2 2 0 0 0-1.75 0z"
  })));
};
export default SvgUkulele;